import { Escala } from '../../inumet_js_lib/model/escalas/escala'

const escalaETP = new Escala(
    [0, 7.5, 15, 22.5, 30, 37.5, 45, 52.5, 60, 67.5, 75, 82.5],
    [
        '#ffffd8',
        '#fff9c2',
        '#ffefad',
        '#ffe097',
        '#ffcd82',
        '#ffb66c',
        '#ff9a56',
        '#ff7a41',
        '#ff562b',
        '#ff2d16',
        '#ff0000',
        '#ff0000',
    ],
    new Array(12).fill('#000')
)

const escalaA = new Escala(
    [-110, -90, -70, -50, -30, -10, 10, 30, 50, 70, 90, 110],
    [
        '#008000',
        '#33992b',
        '#66b356',
        '#99cc82',
        '#cce6ad',
        '#ffffd8',
        '#ffccad',
        '#ff9982',
        '#ff6656',
        '#ff332b',
        '#ff0000',
        '#ff0000',
    ].reverse(),
    new Array(12).fill('#000')
)

const escalaExc = new Escala(
    [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    [
        '#008000',
        '#008000',
        '#1c8e18',
        '#399c30',
        '#55aa48',
        '#71b860',
        '#8ec778',
        '#aad590',
        '#c6e3a8',
        '#e3f1c0',
        '#ffffd8',
    ].reverse(),
    new Array(11).fill('#000')
)

const escalaPAD = new Escala(
    [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
    [
        '#008000',
        '#208e00',
        '#459c00',
        '#72aa00',
        '#a4b800',
        '#c7b000',
        '#d58e00',
        '#e36500',
        '#f13600',
        '#ff0000',
        '#ff0000',
    ].reverse(),
    new Array(11).fill('#000')
)

const escalaAD = new Escala(
    [0, 20, 40, 60, 80, 100, 120, 140, 160, 180, 200],
    [
        '#0b32b2',
        '#1c78dd',
        '#10a6e8',
        '#04dff3',
        '#1ed141',
        '#8ab036',
        '#c4df1e',
        '#fff814',
        '#ff830a',
        '#ff0401',
        '#ff0401',
    ].reverse(),
    new Array(11).fill('#000')
)

const escalaPrecip = new Escala(
    [0, 5, 10, 20, 30, 40, 50, 60, 70, 80, 100, 150, 250, 350, 450],
    [
        '#ffffff',
        '#dbedde',
        '#b6dae3',
        '#92c8e9',
        '#6db6ee',
        '#49a4f4',
        '#2491f9',
        '#007fff',
        '#0070ed',
        '#0060da',
        '#0051c8',
        '#0041b6',
        '#0032a4',
        '#002291',
        '#002291',
    ],
    new Array(15).fill('#000')
)

const escalaIPE = new Escala(
    [-2, -1.5, -1, -0.5, 0.5, 1, 1.5, 2, 999],
    [
        '#D36D33',
        '#F49136',
        '#FFCD6F',
        '#FFEA93',
        '#FFFFFF',
        '#DCEEDC',
        '#B9DCB9',
        '#88BE93',
        '#41925F',
    ],
    [
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
        '#000000',
    ]
)

const escalaFWI = new Escala(
    [10, 15, 20, 999],
    ['#00CC33', '#FFFF00', '#FF9900', '#FF0000'],
    ['#000000', '#000000', '#000000', '#000000']
)

const escalas = {
    escalaPrecip,
    escalaETP,
    escalaA,
    escalaAD,
    escalaExc,
    escalaPAD,
    escalaIPE,
    escalaFWI,
}

export { escalas }
